var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5945 4.95312H1.40547C0.974219 4.95312 0.625 5.28828 0.625 5.70312V16.5781C0.625 16.993 0.974219 17.3281 1.40547 17.3281H18.5922C19.0234 17.3281 19.3727 16.993 19.3727 16.5781V5.70312C19.375 5.28828 19.0258 4.95312 18.5945 4.95312ZM6.4375 15.6406H2.3125V11.8906H6.4375V15.6406ZM6.4375 10.3906H2.3125V6.64062H6.4375V10.3906ZM12.0625 15.6406H7.9375V11.8906H12.0625V15.6406ZM12.0625 10.3906H7.9375V6.64062H12.0625V10.3906ZM17.6875 15.6406H13.5625V11.8906H17.6875V15.6406ZM17.6875 10.3906H13.5625V6.64062H17.6875V10.3906ZM19.1875 0.828125H0.8125C0.709375 0.828125 0.625 0.9125 0.625 1.01562V2.89062C0.625 2.99375 0.709375 3.07812 0.8125 3.07812H19.1875C19.2906 3.07812 19.375 2.99375 19.375 2.89062V1.01562C19.375 0.9125 19.2906 0.828125 19.1875 0.828125Z",
    fill: "#AAB8D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d2c3287293a3c4caafb1491a579120ea.svg";
export { ForwardRef as ReactComponent };